var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import PropTypes from 'prop-types';
import { Switch } from 'react-native';
import fieldLocalState from '../../utils/form/fieldLocalState';
import { DRNUtil } from '@traveloka/district-util';
import { withTheme } from '../../theme';
import R from '../../core-res/R';
import { withSmartKey } from '../../smartkey';
class DRNSwitch extends React.Component {
    render() {
        const _a = this.props, { theme, value, onChange } = _a, restProps = __rest(_a, ["theme", "value", "onChange"]);
        const trackColor = this.props.trackColor || { false: theme.lightSecondary, true: theme.tintPrimary };
        const ios_backgroundColor = this.props.ios_backgroundColor || theme.lightSecondary;
        const thumbColor = this.props.thumbColor || R.color.uiLightPrimary;
        return (<Switch {...restProps} value={value} onValueChange={onChange} trackColor={trackColor} ios_backgroundColor={DRNUtil.isiOS() ? ios_backgroundColor : null} thumbColor={DRNUtil.isiOS() ? null : thumbColor}/>);
    }
}
DRNSwitch.propTypes = {
    value: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    theme: PropTypes.object,
    // String for supporting RNW props
    trackColor: PropTypes.oneOfType([
        PropTypes.shape({
            true: PropTypes.string,
            false: PropTypes.string,
        }),
        PropTypes.string,
    ]),
    ios_backgroundColor: PropTypes.string,
    thumbColor: PropTypes.string,
};
const ThemeSwitch = withTheme(DRNSwitch);
export default withSmartKey(fieldLocalState(ThemeSwitch));
